import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/ProductComparisonBar/productComparisonBar.default"
    ).then((module) => ({
        default: module.ProductComparisonBarDefault
    }))
);
